import { render } from "./newUserModal.vue?vue&type=template&id=efbc2196&scoped=true"
import script from "./newUserModal.vue?vue&type=script&lang=js"
export * from "./newUserModal.vue?vue&type=script&lang=js"

import "./newUserModal.vue?vue&type=style&index=0&id=efbc2196&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efbc2196"]])

export default __exports__